import { render, staticRenderFns } from "./AppInputPhoneNumber.vue?vue&type=template&id=1d3351ac&scoped=true"
import script from "./AppInputPhoneNumber.vue?vue&type=script&lang=js"
export * from "./AppInputPhoneNumber.vue?vue&type=script&lang=js"
import style0 from "./AppInputPhoneNumber.vue?vue&type=style&index=0&id=1d3351ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3351ac",
  null
  
)

export default component.exports